import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { driver } from "driver.js";
import { ExerciseDetailComponent } from 'src/app/main/workout/workout-detail/exercise-detail/exercise-detail.component';
import { SwapExerciseModalComponent } from 'src/app/main/workout/workout-detail/swap-exercise-modal/swap-exercise-modal.component';
import { GuiService } from 'src/app/services/gui.service';
import { RestService } from 'src/app/services/rest.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'vex-workout-detail-favorite',
  templateUrl: './workout-detail-favorite.component.html',
  styleUrls: ['./workout-detail-favorite.component.scss']
})
export class WorkoutDetailFavoriteComponent implements OnInit {
  environment = environment.baseURL;
  workout;
  popOverDetails: any = {
    isOpen: false,
    name: null
  };
  equipPlaceholder = Array(3);
  favoriteLoading = false;
  resumeBtn: boolean = false;
  originalWorkout;
  imageLoadedIds: string[] = [];

  constructor(public guiService: GuiService, private restService: RestService, private activatedRoute: ActivatedRoute, public translate: TranslateService, private router: Router, private dialog: MatDialog) { }

  ngOnInit(): void {
    this.guiService.showSpinner = false;

    this.imageLoadedIds = [];
    let id
    this.activatedRoute.queryParams.subscribe(params => {
      this.workout = null;
      id = params['id'];
    });
    setTimeout(() => {
      this.getWorkout(id);
    }, 100);
    this.popOverDetails.isOpen = false;
  }

  getWorkout(id) {
    if (this.guiService.userLogged) {
      const params = {
        userId: this.guiService.userLogged.user.id,
        workoutId: id
      }
      this.restService.postService('node', '/workout-by-id', params).subscribe((ris) => {
        this.originalWorkout = JSON.parse(JSON.stringify(ris));
        const mixedId = id + '_' + localStorage.getItem('dayIndex');
        this.checkWorkoutStatus(mixedId);
        this.workout = ris;
        this.workout.phases.forEach(phase => {
          if (phase?.i18nName?.['EN'] && phase.i18nName['EN'].toLowerCase().replace(/\s+/g, '') === 'pyramidset') {
            phase.exercises = this.mergeConsecutiveExercisesById(phase.exercises);
            console.debug(phase)
            const newSetNumber = phase.exercises[0].repetitions.split('-');
            phase.repetitions = newSetNumber.length;
          }
        });
        this.retriveSwappedExercises(mixedId, ris);
        setTimeout(() => {
          localStorage.getItem('tourWorkoutDetailShowed') ? null : this.startTour();
        }, 800);
      })
    } else {
      this.guiService.goTo('main/home');
    }
  }

  equipNameConvert(equip) {
    return equip.replace(/[^A-Z0-9]+/ig, "_");
  }

  convertToMMSS(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    const formattedMinutes = minutes < 10 ? '0' + minutes : minutes.toString();
    const formattedSeconds = remainingSeconds < 10 ? '0' + remainingSeconds : remainingSeconds.toString();

    return `${formattedMinutes}:${formattedSeconds}`;
  }

  equipFullName(name) {
    this.popOverDetails.isOpen = false;
    setTimeout(() => {
      this.popOverDetails = {
        isOpen: true,
        name: name
      }
    }, 300);
  }

  elaborateExerciseDetail(exerciseId: any) {
    if (this.workout.exerciseMap[exerciseId].equipmentIds && this.workout.exerciseMap[exerciseId].equipmentIds.length > 0) {
      const equipCoverted = [];
      this.workout.exerciseMap[exerciseId].equipmentIds.forEach(element => {
        equipCoverted.push(this.workout.equipmentsMap[element])
      });
      this.openModalExerciseDetail(this.workout.exerciseMap[exerciseId], equipCoverted);
    } else {
      this.openModalExerciseDetail(this.workout.exerciseMap[exerciseId]);
    }
  }

  openModalExerciseDetail(exercise: any, equips?: any): void {
    const dialogRef = this.dialog.open(ExerciseDetailComponent, {
      disableClose: true,    // come backdropDismiss: false
      data: {
        exercise,
        equips: equips || null
      },
      width: '600px'  // opzionale: puoi personalizzare dimensioni
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log('Dati ricevuti dal dialog:', result);
        // gestisci i dati di ritorno qui
      }
    });
  }

  openModalSwapExercise(
    exercise: any,
    exerciseAlternative: any,
    phaseIndex: number,
    exerciseIndex: number
  ): void {
    const dialogRef = this.dialog.open(SwapExerciseModalComponent, {
      disableClose: true, // equivale a backdropDismiss: false
      panelClass: '', // cssClass equivalente
      data: {
        exercise,
        exerciseAlternative
      },
      width: '600px' // puoi personalizzare larghezza o altro
    });

    dialogRef.afterClosed().subscribe(dataReturned => {
      if (dataReturned) {
        console.log('Dati ricevuti dal dialog:', dataReturned);
        if (dataReturned === 'confirm') {
          const exerciseObj = this.workout.phases[phaseIndex].exercises[exerciseIndex];
          exerciseObj.swapped = !exerciseObj.swapped;
          exerciseObj.exerciseId = exerciseAlternative._id;
          this.workout.exerciseMap[exerciseAlternative._id].exerciseAlternativeId = exercise._id;
        }
      }
    });
  }

  setFavoriteStatus() {
    this.favoriteLoading = true;
    const program = this.guiService.userLogged?.workoutInfo?.programs[this.workout.workoutProgramId];
    const param = {
      workoutId: this.workout._id,
      week: program.week,
      day: localStorage.getItem('dayIndex'),
      programId: this.workout.workoutProgramId
    };
    this.restService.postService('node', '/workout-favorite-status', { userId: this.guiService.userLogged.user.id, favorite: param }).subscribe((ris) => {
      this.guiService.userLogged.workoutInfo.favorites = ris;
      this.favoriteLoading = false;
    })
  }

  isFavorite(): boolean {
    const favorites = this.guiService.userLogged?.workoutInfo?.favorites ? this.guiService.userLogged?.workoutInfo?.favorites : this.guiService.userLogged.workoutInfo.favorites = [];
    const program = this.guiService.userLogged?.workoutInfo?.programs[this.workout.workoutProgramId];
    const param = {
      workoutId: this.workout._id,
      week: program.week,
      day: localStorage.getItem('dayIndex'),
      programId: this.workout.workoutProgramId
    };
    return favorites.some(fav =>
      fav.workoutId === param.workoutId &&
      fav.week === param.week &&
      fav.day === param.day &&
      fav.programId === param.programId
    );
  }

  startWorkout() {
    localStorage.setItem('workout', JSON.stringify(this.workout));
    this.guiService.goTo('main/workout-execution')
  }

  retriveSwappedExercises(workoutId, workout) {
    const currentProgram = this.guiService.userLogged.workoutInfo.currentProgram;
    const week = this.guiService.userLogged.workoutInfo.programs[currentProgram].week;
    const workoutObj = this.guiService.userLogged.workoutInfo.programs[currentProgram].progress['week_' + week][workoutId];
    if (workoutObj && workoutObj.swappedExercises) {
      console.debug(workoutObj)
      const swappedExercises = workoutObj.swappedExercises;

      Object.entries(swappedExercises).forEach(([key, value]: any) => {
        workout.phases.forEach(phase => {
          const foundExercise = phase.exercises.find(x => x.exerciseId === key);
          if (foundExercise) {
            foundExercise.swapped = true;
            foundExercise.exerciseId = value;
            workout.exerciseMap[value].exerciseAlternativeId = key;
          }
        });
      });
    }
  }

  checkWorkoutStatus(workoutId) {
    const currentProgram = this.guiService.userLogged.workoutInfo.currentProgram;
    const week = this.guiService.userLogged.workoutInfo.programs[currentProgram].week;

    if (this.guiService.userLogged.workoutInfo.programs[currentProgram].progress['week_' + week][workoutId] && this.guiService.userLogged.workoutInfo.programs[currentProgram].progress['week_' + week][workoutId].status === 'PAUSED') {
      this.resumeBtn = true;
    } else {
      this.resumeBtn = false;
    }
  }

  resumeWorkout() {
    localStorage.setItem('workout', JSON.stringify(this.workout));
    const mixedId = this.workout._id + '_' + localStorage.getItem('dayIndex');
    const currentProgram = this.guiService.userLogged.workoutInfo.currentProgram;
    const week = this.guiService.userLogged.workoutInfo.programs[currentProgram].week;
    const phaseNumber = this.guiService.userLogged.workoutInfo.programs[currentProgram].progress['week_' + week][mixedId].phaseNumber ?? 0;
    const setNumber = this.guiService.userLogged.workoutInfo.programs[currentProgram].progress['week_' + week][mixedId].setNumber;
    const lastExerciseId = this.guiService.userLogged.workoutInfo.programs[currentProgram].progress['week_' + week][mixedId].lastExerciseId;

    let exerciseIndex;

    this.workout.phases.forEach(phase => {
      if (phase.exercises.findIndex(x => x.exerciseId === lastExerciseId) > -1) {
        exerciseIndex = phase.exercises.findIndex(x => x.exerciseId === lastExerciseId);
      }
    });

    if (exerciseIndex === -1) {
      const alternativeExerciseId = this.workout.exerciseMap[lastExerciseId].exerciseAlternativeId;

      this.workout.phases.forEach(phase => {
        if (phase.exercises.findIndex(x => x.exerciseId === alternativeExerciseId) > -1) {
          exerciseIndex = phase.exercises.findIndex(x => x.exerciseId === alternativeExerciseId);
        }
      });
    }
    this.router.navigate(['main/workout-execution'], {
      queryParams: { exerciseNumber: exerciseIndex, setCounter: setNumber, phaseNumber: phaseNumber }
    });
  }

  restartWorkout() {
    // this.workout = this.originalWorkout;
    this.workout.phases.forEach(phase => {
      if (phase?.i18nName?.['EN'] && phase.i18nName['EN'].toLowerCase().replace(/\s+/g, '') === 'pyramidset') {
        phase.exercises = this.mergeConsecutiveExercisesById(phase.exercises);
        const newSetNumber = phase.exercises[0].repetitions.split('-');
        phase.repetitions = newSetNumber.length;
      }
    });
    localStorage.setItem('workout', JSON.stringify(this.workout));
    this.guiService.goTo('main/workout-execution')
  }


  mergeConsecutiveExercisesById(exercises: any[]): any[] {
    const result: any[] = [];
    let buffer: any[] = [];

    exercises.forEach((exercise, index) => {
      const prev = buffer[0];

      if (!prev || prev.exerciseId === exercise.exerciseId) {
        buffer.push(exercise);
      } else {
        result.push(this.mergeGroup(buffer));
        buffer = [exercise];
      }
    });

    // aggiungi ultimo gruppo rimasto
    if (buffer.length > 0) {
      result.push(this.mergeGroup(buffer));
    }

    return result;
  }

  mergeGroup(group: any[]): any {
    if (group.length === 1) {
      return group[0];
    }

    const base = { ...group[0] };
    const tmpArrRep = group.map(e => e.repetitions);
    base.repetitions = group.map(e => e.repetitions).join('-');
    base.accorped = true;
    base.arrRepetitions = tmpArrRep;
    return base;
  }

  startTour(): void {
    localStorage.setItem('tourWorkoutDetailShowed', 'true')

    const driverObj = driver({
      showProgress: true,
      allowClose: true,
      steps: [
        { element: '.equipments-slider', popover: { title: this.translate.instant('TUTORIALS.workout-detail.prepareEquipmentTitle'), description: this.translate.instant('TUTORIALS.workout-detail.prepareEquipmentDescription') } },
        { element: '.phase', popover: { title: this.translate.instant('TUTORIALS.workout-detail.trainingStructureTitle'), description: this.translate.instant('TUTORIALS.workout-detail.trainingStructureDescription') } },
        { element: '.exercise-detail-icon', popover: { title: this.translate.instant('TUTORIALS.workout-detail.exerciseDetailTitle'), description: this.translate.instant('TUTORIALS.workout-detail.exerciseDetailDescription') } },
        { element: '.swap-icon', popover: { title: this.translate.instant('TUTORIALS.workout-detail.switchExerciseTitle'), description: this.translate.instant('TUTORIALS.workout-detail.switchExerciseDescription') } },
        { element: '.start-workout-btn', popover: { title: this.translate.instant('TUTORIALS.workout-detail.readyToStartTitle'), description: this.translate.instant('TUTORIALS.workout-detail.readyToStartDescription') } },
        { element: '.favorite-icon', popover: { title: this.translate.instant('TUTORIALS.workout-detail.saveFavoriteTitle'), description: this.translate.instant('TUTORIALS.workout-detail.saveFavoriteDescription') } }
      ]
    });

    driverObj.drive();
  }

  onImageLoad(id) {
    this.imageLoadedIds.push(id);
    console.log('✅ Immagine card ex detail caricata con successo');
  }

  back(){
    localStorage.removeItem('resumeFavorite');
    localStorage.removeItem('workout');
    this.guiService.goTo('main/favorite-workouts');
  }

}

